module.exports = __webpack_public_path__ + "img/logo.f2623c13.png";